package app.bloomey.web.utils

private const val emailRegex = "^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\$"
val String.isValidEmail: Boolean
    get() {
        return this.matches(emailRegex.toRegex())
    }
